// @ts-nocheck
export interface StoreToasterProps {
    timeoutLength: number;
}
export const storeToasterProps: StoreToasterProps = {
    timeoutLength: 30000,
};
